import React, { useRef } from "react";
import { Box, Drawer as ChakraDrawer, DrawerBody, DrawerContent, DrawerOverlay, } from "@chakra-ui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { IconButton } from "./icon-button";
import { Heading } from "./heading";
export function Drawer({ isOpen, title, children, size = "sm", onClose, }) {
    const closeButton = useRef(null);
    return (React.createElement(ChakraDrawer, { isOpen: isOpen, size: size, initialFocusRef: closeButton, onClose: onClose },
        React.createElement(DrawerOverlay, null),
        React.createElement(DrawerContent, null,
            React.createElement(Box, { as: "header", display: "flex", alignItems: "center", px: 6, py: 3 },
                React.createElement(Box, { flex: "1", minWidth: 0 },
                    React.createElement(Heading, { isTruncated: true }, title)),
                React.createElement(IconButton, { ref: closeButton, icon: XMarkIcon, "aria-label": "Close", onClick: onClose })),
            React.createElement(DrawerBody, null, children))));
}
